import React, { useState } from 'react';
import { useRouter } from 'next/router';

import './CoursesIntro.scss';
import Transition from '../Transition/Transition.jsx';
import icons from '../../shared/assets/icons/redesign';
import { trackAction, usePlatform } from '../../helpers/tracking';
import CoursesLoginPopup from '../CoursesLoginPopup/CoursesLoginPopup.jsx';

const { Check } = icons;

export default function CoursesIntro({ config, user, addUserEvent }) {
  const router = useRouter();
  const platform = usePlatform();

  const [popup, showPopup] = useState(false);

  // https://team.linkorb.com/cards/6707
  const paymentFlow1 = user?.segmentUsers?.find(({ segment }) =>
    [
      '1d4025ff5af225dc3d6d7f764224eed84860deb1',
      'd935a3fa759c3413a1e3cb0403c0589bb2d1a83f',
      'cd68f4bb8149944020a3cd0ef6a2459aa3dccb84'
    ].includes(segment.identifier)
  );

  // https://team.linkorb.com/cards/6715
  const paymentFlow2 = user?.segmentUsers?.find(({ segment }) =>
    [
      'b2c1f57e9f0b307b7a99cff2d77121376270438b',
      'f6a9efac21a171657612d18071ea3863c0e599fa'
    ].includes(segment.identifier)
  );

  const [link, price] = paymentFlow1
    ? ['/zwangerschapscursus-2/betalen/verzekering', '74,95']
    : paymentFlow2
    ? ['/zwangerschapscursus-3/betalen/verzekering', '49,95']
    : ['/zwangerschapscursus/betalen/verzekering', '99,95'];

  return (
    <div className="coursesIntro">
      <Transition on={popup}>
        <CoursesLoginPopup config={config} showPopup={showPopup} />
      </Transition>

      <h2 className="coursesIntro-title">
        Volg jouw (zwangerschaps) cursus nu lekker vanuit huis!
      </h2>

      <p className="coursesIntro-text">
        Een compleet cursuspakket waar je zowel zwangerschaps-, beval- en
        babycursussen krijgt? Het kan. Met 12 cursussen zorgen onze
        professionals ervoor dat jij en je partner alles aankunnen wat er op
        jullie pad komt tijdens en na de zwangerschap. Leer alles wat je wilt
        weten en volg de cursus op jouw moment, in jouw veilige thuisomgeving.
      </p>

      <ul className="coursesIntro-review-list">
        <li className="coursesIntro-review-list-item">
          9.5 Zwangerschapscursus
          <q>Geweldige cursus. En helemaal gratis!</q>
        </li>

        <li className="coursesIntro-review-list-item">
          8.0 Bevallingscursus
          <q>Informatief, prettig om naar te kijken</q>
        </li>

        <li className="coursesIntro-review-list-item">
          8.3 Borstvoedingscursus
          <q>Fijn overzicht</q>
        </li>

        <li className="coursesIntro-review-list-item">
          8.1 Snelcursus voor de partner
          <q>Heel fijn om deze cursussen samen met mijn partner te bekijken.</q>
        </li>

        <li className="coursesIntro-review-list-item">
          8.3 Seksualiteit tijdens en na de zwangerschap
          <q>Doorbreekt taboe en dat is prettig</q>
        </li>
      </ul>

      {(!user.username || (user.username && !user.hasCourseAccess)) && (
        <button
          className="coursesIntro-button coursesIntro-button-primary"
          onClick={() => {
            if (user.username) router.push(link);
            else showPopup(true);

            addUserEvent({
              variables: { type: 'courses-buybutton', data: '{}' }
            });

            trackAction(platform, 'courseswelkom', 'clickbuybutton');
          }}
        >
          Kopen
        </button>
      )}

      <button
        onClick={() => {
          router.push('/verzekering/cursus-vergoeding');

          trackAction(
            platform,
            'courseswelkom',
            'clickinsurancereimbursementbutton'
          );
        }}
        className="coursesIntro-button coursesIntro-button-secondary"
      >
        Vergoedt mijn verzekering?
      </button>

      <div className="coursesIntro-text-small">
        <img
          alt="courses-users"
          src="https://upr.io/dBEyMP.png"
          className="coursesIntro-img"
        />

        <p>
          Maartje en
          <span className="coursesIntro-text-bold">
            {' '}
            {calculateCoursesMemberCount()} anderen{' '}
          </span>
          hebben toegang tot cursussen.
        </p>
      </div>

      <ul className="coursesIntro-list">
        <li className="coursesIntro-list-item">
          <div className="coursesIntro-list-item-icon-wrap">
            <Check className="coursesIntro-list-item-icon" />
          </div>
          Gratis, afhankelijk van je verzekering. Anders nu tijdelijk {price}{' '}
          euro ipv 149,95 euro
        </li>

        <li className="coursesIntro-list-item">
          <div className="coursesIntro-list-item-icon-wrap">
            <Check className="coursesIntro-list-item-icon" />
          </div>
          Afgestemd op je zwangerschap, bevalling, de babytijd en je partner
        </li>

        <li className="coursesIntro-list-item">
          <div className="coursesIntro-list-item-icon-wrap">
            <Check className="coursesIntro-list-item-icon" />
          </div>
          Meer dan 100 video’s en 1000+ minuten materiaal
        </li>

        <li className="coursesIntro-list-item">
          <div className="coursesIntro-list-item-icon-wrap">
            <Check className="coursesIntro-list-item-icon" />
          </div>
          18 maanden onbeperkt toegang tot 12 online cursussen
        </li>
      </ul>

      <button
        className="coursesIntro-button coursesIntro-button-secondary"
        onClick={() => {
          router.push(
            '/10-zwangerschaps-en-bevalcursussen-onbeperkt-en-online-bij-zwangerenportaalnl'
          );

          trackAction(platform, 'courseswelkom', 'clickmoreinformationbutton');
        }}
      >
        Meer informatie
      </button>
    </div>
  );
}

// https://team.linkorb.com/cards/7029
export function calculateCoursesMemberCount() {
  const initialDateToTrackCoursesMemberCount = new Date('2022-12-22');

  const differenceInDays = Math.ceil(
    (new Date().getTime() - initialDateToTrackCoursesMemberCount.getTime()) /
      (1000 * 3600 * 24)
  );

  return (7891 + differenceInDays * 3).toLocaleString('nl-NL');
}
